import BarChart from './ui/BarChart';
import WidgetHeader from './ui/WidgetHeader';
import PieChart from './ui/PieChart';
import Link from './ui/Link';
import EventHeader from './ui/EventHeader';
import SimpleEventHeader from './ui/SimpleEventHeader';
import EventCell from './ui/EventCell';
import EventCellPredictor from './ui/EventCellPredictor';
import TeamLogo from './ui/TeamLogo';
import PlayerLogo from './ui/PlayerLogo';
import Pitch from './ui/Pitch';
import DropdownIcon from './ui/DropdownIcon';
import TournamentName from './ui/TournamentName';
import NavBar from './ui/NavBar';

var widgets = {
    PieChart,
    BarChart,
    WidgetHeader,
    Link,
    EventHeader,
    SimpleEventHeader,
    EventCell,
    TeamLogo,
    PlayerLogo,
    Pitch,
    DropdownIcon,
    TournamentName,
    NavBar,
    EventCellPredictor,
    nbsp: '\u00a0'
};

export default widgets;
export { widgets };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/UI.js
 **/